import React from "react";
import {
  FaChalkboardTeacher,
  FaBookOpen,
  FaUniversity,
  FaBriefcase,
} from "react-icons/fa";
import "./AdvertiseWithUs.css";

export default function AdvertiseWithUs() {
  return (
    <div className="advertise-page">
      <div className="advertise-header">
        <h1>
          Advertise with <span>IndianJobs360</span>
        </h1>
        <p>
          Reach thousands of students, job seekers, and professionals every day.
          Whether you are a coaching institute, book publisher, study material
          provider, college, or have job openings — we help you connect with the
          right audience.
        </p>
      </div>

      <div className="advertise-grid">
        <div className="advertise-card">
          <FaChalkboardTeacher className="advertise-icon blue" />
          <h3>Coaching Classes</h3>
          <p>
            Promote your coaching center to students actively preparing for
            government exams.
          </p>
        </div>

        <div className="advertise-card">
          <FaBookOpen className="advertise-icon orange" />
          <h3>Books & Study Material</h3>
          <p>
            Showcase your books, eBooks, and study material to a targeted
            audience.
          </p>
        </div>

        <div className="advertise-card">
          <FaUniversity className="advertise-icon green" />
          <h3>Colleges & Certifications</h3>
          <p>
            Highlight your courses, certifications, and admissions to aspiring
            learners.
          </p>
        </div>

        <div className="advertise-card">
          <FaBriefcase className="advertise-icon purple" />
          <h3>Job Openings</h3>
          <p>
            Share your company’s job vacancies with our active job-seeking
            audience.
          </p>
        </div>
      </div>

      <div className="advertise-cta">
        <h2>Ready to Promote Your Brand?</h2>
        <p>
          Let’s discuss how we can help you grow. Reach your audience today!
        </p>
        <a href="mailto:advertise@gmail.com">Contact Us Now</a>
      </div>
    </div>
  );
}
